import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import shuffle from 'lodash/shuffle';

import MediaImageSliderRow from './MediaImageSliderRow';

import generalStyles from './style/general.module.css';

const cx = classNames.bind({ ...generalStyles });

export default function MediaImageSlider({
  firstBatch,
  secondBatch,
  thirdBatch,
}) {
  const firstBatchImages = shuffle(firstBatch);
  const secondBatchImages = shuffle(secondBatch);
  const thirdBatchImages = shuffle(thirdBatch);

  return (
    <div className={cx('imagesSlider')}>
      <div className={cx('rowsContainer')}>
        <MediaImageSliderRow images={firstBatchImages} />
        <MediaImageSliderRow images={secondBatchImages} isReversed />
        <div className="display-none breakPointS-display-block">
          <MediaImageSliderRow images={thirdBatchImages} />
        </div>
      </div>
    </div>
  );
}

MediaImageSlider.propTypes = {
  firstBatch: PropTypes.array.isRequired,
  secondBatch: PropTypes.array.isRequired,
  thirdBatch: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/Media/MediaImageSlider/index.js